<!-- <div class="row">
    <div class="col-8 showing-text mt-2">
        Showing: {{page}} to {{size}} of {{count}} entries
    </div>
    <div class="col-3 mt-select-2 mobile-hidden">
        <tui-select tuiTextfieldSize="s" [(ngModel)]="selectedValue" (ngModelChange)="onLimitChange($event)">
            Page
            <input placeholder="Select Page" tuiTextfield />
            <tui-data-list-wrapper *tuiDataList [items]="pageLimitOptions"></tui-data-list-wrapper>
        </tui-select>
    </div>
</div> -->

<div class="d-flex flex-row">
    <div class="p-2 mt-0 w-300-px">
        Showing: {{ startRow }} to {{ endRow }} of {{ count }} entries
    </div>
    <!-- <tui-select tuiTextfieldSize="s" [(ngModel)]="selectedValue" (ngModelChange)="onLimitChange($event)" style="width:135px;">Page
        <input placeholder="Select Page" tuiTextfieldLegacy />
        <tui-data-list-wrapper *tuiDataList [items]="pageLimitOptions"></tui-data-list-wrapper>
    </tui-select> -->
    <tui-textfield style="width:135px;" tuiChevron [stringify]="STRINGIFY_DROPDOWN_DISPLAY_ITEM"
        tuiTextfieldSize="s" [tuiTextfieldCleaner]="false" class="b-form">
        <input tuiComboBox (ngModelChange)="onLimitChange($event)" [(ngModel)]="selectedValue" placeholder="Select Page"
             />
        <tui-data-list-wrapper *tuiDropdown new [items]="pageLimitOptions | tuiFilterByInput"
            [itemContent]="STRINGIFY_DROPDOWN_DISPLAY_ITEM | tuiStringifyContent" />
    </tui-textfield>
</div>
